{
    "prince": {
        "key": "prince",
        "isDead": false,
        "position": {
            "x": 8,
            "y": 2,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "school/bow",
        "power": 60,
        "maxhealth": 70,
        "imageKey": "prince",
        "level": 5,
        "title": "Prince",
        "subtitle": "Student"
    },
    "teacher": {
        "position": {
            "x": 3,
            "y": 6,
            "z": 1
        },
        "key": "teacher",
        "affiliation": "none",
        "level": null,
        "equippedItem": null,
        "properties": [
            "flipped"
        ]
    },
    "OVrn2": {
        "position": {
            "x": 6,
            "y": 2,
            "z": 1
        },
        "jobKey": "school/mage",
        "key": "OVrn2",
        "level": 5,
        "power": 60,
        "maxhealth": 70,
        "imageKey": "prepred",
        "title": "Upperclassman"
    },
    "XlWnq": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "jobKey": "school/axe",
        "key": "XlWnq",
        "level": 5,
        "power": 60,
        "maxhealth": 70,
        "imageKey": "prepgreen",
        "title": "Upperclassman"
    },
    "BOaF-": {
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "jobKey": "school/axe",
        "key": "BOaF-",
        "level": 5,
        "power": 60,
        "maxhealth": 70,
        "imageKey": "jockgreen",
        "title": "Upperclassman"
    },
    "7wvgn": {
        "position": {
            "x": 9,
            "y": 2,
            "z": 1
        },
        "jobKey": "school/sword",
        "key": "7wvgn",
        "level": 5,
        "power": 60,
        "maxhealth": 70,
        "imageKey": "jockred",
        "title": "Upperclassman"
    }
}